function initializeStepForm(container) {
  const steps = container.querySelectorAll(".step");
  const totalSteps = steps.length;
  const progressBar = container.querySelector(".progress-bar");
  const stepCircles = container.querySelectorAll(".step-circle");
  const form = container.querySelector("form"); // Single form element
  let currentStep = 1;

  if (progressBar) {
    function displayStep(stepNumber) {
      if (stepNumber >= 1 && stepNumber <= totalSteps) {
        steps.forEach((step, index) => {
          step.style.display = index + 1 === stepNumber ? "block" : "none";
        });

        stepCircles.forEach((circle, index) => {
          circle.classList.toggle("active", index + 1 === stepNumber);
        });

        updateProgressBar();
      }
    }

    function updateProgressBar() {
      const progressPercentage = (currentStep / totalSteps) * 100;
      progressBar.style.width = `${progressPercentage}%`;
    }


    // Commenting for testing purpose 
    // function validateStepFields(step) {
    //   const fields = step.querySelectorAll(
    //     "input, select, textarea, .searchable-select"
    //   );
    //   let isValid = true;

    //   // Temporarily remove 'was-validated' to avoid triggering errors for hidden fields
    //   form.classList.remove("was-validated");

    //   // Validate only visible fields
    //   fields.forEach((field) => {
    //     // Handle .searchable-select (Bootstrap-Select) case
    //     if (field.classList.contains("searchable-select")) {
    //       const selectElement = field
    //         .closest(".bootstrap-select")
    //         .querySelector("select");
    //       const isSelectValid = selectElement.checkValidity();
    //       const isSelected =
    //         selectElement.value !== "" &&
    //         selectElement.value !== null &&
    //         selectElement.value !== "Please Select";

    //       if (isSelectValid && isSelected) {
    //         // Apply valid classes to both select and its bootstrap-select wrapper
    //         selectElement.classList.remove("is-invalid");
    //         selectElement.classList.add("is-valid");
    //         field.closest(".bootstrap-select").classList.remove("is-invalid");
    //         field.closest(".bootstrap-select").classList.add("is-valid");
    //       } else {
    //         // Apply invalid classes if not valid
    //         selectElement.classList.remove("is-valid");
    //         selectElement.classList.add("is-invalid");
    //         field.closest(".bootstrap-select").classList.remove("is-valid");
    //         field.closest(".bootstrap-select").classList.add("is-invalid");
    //         isValid = false;
    //       }

    //       // Add event listener for real-time validation
    //       selectElement.addEventListener("change", () => {
    //         const isSelected =
    //           selectElement.value !== "" &&
    //           selectElement.value !== null &&
    //           selectElement.value !== "Please Select";
    //         if (isSelected) {
    //           // Apply valid state
    //           selectElement.classList.remove("is-invalid");
    //           selectElement.classList.add("is-valid");
    //           field.closest(".bootstrap-select").classList.remove("is-invalid");
    //           field.closest(".bootstrap-select").classList.add("is-valid");
    //         } else {
    //           // Apply invalid state
    //           selectElement.classList.remove("is-valid");
    //           selectElement.classList.add("is-invalid");
    //           field.closest(".bootstrap-select").classList.remove("is-valid");
    //           field.closest(".bootstrap-select").classList.add("is-invalid");
    //         }
    //       });
    //     } else if (!field.checkValidity()) {
    //       // Regular input, select, or textarea validation
    //       field.classList.add("is-invalid");
    //       isValid = false;
    //     } else {
    //       // If valid, ensure valid classes are applied
    //       field.classList.remove("is-invalid");
    //       field.classList.add("is-valid");
    //     }
    //   });

    //   // Add 'was-validated' to display validation errors for current step
    //   if (!isValid) {
    //     form.classList.add("was-validated");
    //   }

    //   return isValid;
    // }

    // function validateStepFields(step) {
    //   const fields = step.querySelectorAll(
    //     "input, select, textarea, .searchable-select, .file-upload-container"
    //   );
    //   let isValid = true;

    //   // Temporarily remove 'was-validated' to avoid triggering errors for hidden fields
    //   form.classList.remove("was-validated");

    //   fields.forEach((field) => {
    //     // **Ignore hidden fields**
    //     if (field.offsetParent === null) {
    //       return; // Skip validation for hidden fields
    //     }

    //     // Handle file-upload-container validation
    //     if (field.classList.contains("file-upload-container")) {
    //       console.log(field);
    //       const fileInput = field.querySelector("input[type='file']");
    //       const fileLabel = field.querySelector("label");

    //       if (!fileInput.files.length) {
    //         fileLabel.classList.add("is-invalid");
    //         fileLabel.classList.remove("is-valid");
    //         isValid = false;
    //       } else {
    //         fileLabel.classList.remove("is-invalid");
    //         fileLabel.classList.add("is-valid");
    //       }

    //       // Add event listener to remove error on file selection
    //       fileInput.addEventListener("change", () => {
    //         if (fileInput.files.length) {
    //           fileLabel.classList.remove("is-invalid");
    //           fileLabel.classList.add("is-valid");
    //         }
    //       });
    //     }

    //     // Handle searchable-select (Bootstrap-Select) case
    //     if (field.classList.contains("searchable-select")) {
    //       const selectElement = field
    //         .closest(".bootstrap-select")
    //         .querySelector("select");
    //       const isSelectValid = selectElement?.checkValidity();
    //       const isSelected =
    //         selectElement.value !== "" &&
    //         selectElement.value !== null &&
    //         selectElement.value !== "Please Select";

    //       if (isSelectValid && isSelected) {
    //         selectElement.classList.remove("is-invalid");
    //         selectElement.classList.add("is-valid");
    //         field.closest(".bootstrap-select").classList.remove("is-invalid");
    //         field.closest(".bootstrap-select").classList.add("is-valid");
    //       } else {
    //         selectElement.classList.remove("is-valid");
    //         selectElement.classList.add("is-invalid");
    //         field.closest(".bootstrap-select").classList.remove("is-valid");
    //         field.closest(".bootstrap-select").classList.add("is-invalid");
    //         isValid = false;
    //       }

    //       // Add event listener for real-time validation
    //       selectElement.addEventListener("change", () => {
    //         const isSelected =
    //           selectElement.value !== "" &&
    //           selectElement.value !== null &&
    //           selectElement.value !== "Please Select";
    //         if (isSelected) {
    //           selectElement.classList.remove("is-invalid");
    //           selectElement.classList.add("is-valid");
    //           field.closest(".bootstrap-select").classList.remove("is-invalid");
    //           field.closest(".bootstrap-select").classList.add("is-valid");
    //         } else {
    //           selectElement.classList.remove("is-valid");
    //           selectElement.classList.add("is-invalid");
    //           field.closest(".bootstrap-select").classList.remove("is-valid");
    //           field.closest(".bootstrap-select").classList.add("is-invalid");
    //         }
    //       });
    //     } else if (!field?.checkValidity()) {
    //       field.classList.add("is-invalid");
    //       isValid = false;
    //     } else {
    //       field.classList.remove("is-invalid");
    //       field.classList.add("is-valid");
    //     }
    //   });

    //   // Show validation errors only if invalid
    //   if (!isValid) {
    //     form.classList.add("was-validated");
    //   }

    //   return isValid;
    // }
    function validateStepFields(step) {
      const fields = step.querySelectorAll(
        "input, select, textarea, .searchable-select, .file-upload-container"
      );
      let isValid = true;

      // Temporarily remove 'was-validated' to avoid triggering errors for hidden fields
      form.classList.remove("was-validated");

      fields.forEach((field) => {
        // **Ignore hidden fields**
        if (field.offsetParent === null) {
          return; // Skip validation for hidden fields
        }

        // Handle file-upload-container validation
        if (field.classList.contains("file-upload-container")) {
          console.log(field);
          const fileInput = field.querySelector("input[type='file']");
          const fileLabel = field.querySelector("label");

          if (!fileInput.files.length) {
            fileLabel.classList.add("is-invalid");
            fileLabel.classList.remove("is-valid");
            isValid = false;
          } else {
            fileLabel.classList.remove("is-invalid");
            fileLabel.classList.add("is-valid");
          }

          // Add event listener to remove error on file selection
          fileInput.addEventListener("change", () => {
            if (fileInput.files.length) {
              fileLabel.classList.remove("is-invalid");
              fileLabel.classList.add("is-valid");
            }
          });
        }

        // Handle searchable-select (Bootstrap-Select) case
        else if (field.classList.contains("searchable-select")) {
          const selectElement = field
            .closest(".bootstrap-select")
            .querySelector("select");
          const isSelectValid = selectElement?.checkValidity();
          const isSelected =
            selectElement.value !== "" &&
            selectElement.value !== null &&
            selectElement.value !== "Please Select";

          if (isSelectValid && isSelected) {
            selectElement.classList.remove("is-invalid");
            selectElement.classList.add("is-valid");
            field.closest(".bootstrap-select").classList.remove("is-invalid");
            field.closest(".bootstrap-select").classList.add("is-valid");
          } else {
            selectElement.classList.remove("is-valid");
            selectElement.classList.add("is-invalid");
            field.closest(".bootstrap-select").classList.remove("is-valid");
            field.closest(".bootstrap-select").classList.add("is-invalid");
            isValid = false;
          }

          // Add event listener for real-time validation
          selectElement.addEventListener("change", () => {
            const isSelected =
              selectElement.value !== "" &&
              selectElement.value !== null &&
              selectElement.value !== "Please Select";
            if (isSelected) {
              selectElement.classList.remove("is-invalid");
              selectElement.classList.add("is-valid");
              field.closest(".bootstrap-select").classList.remove("is-invalid");
              field.closest(".bootstrap-select").classList.add("is-valid");
            } else {
              selectElement.classList.remove("is-valid");
              selectElement.classList.add("is-invalid");
              field.closest(".bootstrap-select").classList.remove("is-valid");
              field.closest(".bootstrap-select").classList.add("is-invalid");
            }
          });
        }

        // Handle standard input, select, and textarea validation
        else if (
          field.tagName === "INPUT" ||
          field.tagName === "SELECT" ||
          field.tagName === "TEXTAREA"
        ) {
          if (!field.checkValidity()) {
            field.classList.add("is-invalid");
            isValid = false;
          } else {
            field.classList.remove("is-invalid");
            field.classList.add("is-valid");
          }
        }
      });

      // Show validation errors only if invalid
      if (!isValid) {
        form.classList.add("was-validated");
      }

      return isValid;
    }

    stepCircles.forEach((circle, index) => {
      circle.addEventListener("click", () => {
        if (
          index + 1 <= currentStep ||
          validateStepFields(steps[currentStep - 1])
        ) {
          currentStep = index + 1;
          displayStep(currentStep);
          form.classList.remove("was-validated"); // Clear validation state for the new step
        }
      });
    });

    container.querySelectorAll(".next-step").forEach((button) => {
      button.addEventListener("click", () => {
        window.scrollTo({ top: "300" });
        if (currentStep < totalSteps) {
          if (validateStepFields(steps[currentStep - 1])) {
            steps[currentStep - 1].classList.add(
              "animate__animated",
              "animate__fadeOutLeft"
            );
            currentStep++;
            setTimeout(() => {
              displayStep(currentStep);
              form.classList.remove("was-validated"); // Clear validation state for the new step
              steps[currentStep - 1].classList.remove(
                "animate__animated",
                "animate__fadeOutLeft"
              );
              steps[currentStep - 1].classList.add(
                "animate__animated",
                "animate__fadeInRight"
              );
            }, 500);
          }
        }
      });
    });

    container.querySelectorAll(".prev-step").forEach((button) => {
      button.addEventListener("click", () => {
        window.scrollTo({ top: "300" });
        if (currentStep > 1) {
          steps[currentStep - 1].classList.add(
            "animate__animated",
            "animate__fadeOutRight"
          );
          currentStep--;
          setTimeout(() => {
            displayStep(currentStep);
            form.classList.remove("was-validated"); // Clear validation state for the new step
            steps[currentStep - 1].classList.remove(
              "animate__animated",
              "animate__fadeOutRight"
            );
            steps[currentStep - 1].classList.add(
              "animate__animated",
              "animate__fadeInLeft"
            );
          }, 500);
        }
      });
    });

    steps.forEach((step, index) => {
      step.style.display = index === 0 ? "block" : "none";
    });

    displayStep(1);
  }
}
document.querySelectorAll("#container").forEach((formContainer) => {
  initializeStepForm(formContainer);
});
